import { useState } from "react";
import { Box, Typography, TextField } from "@mui/material";
import { Modal, Icon } from "pepsico-ds";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../../utils/Loader";
import { postAPI } from "../../API/ApiService";
import { BASE_URL } from "../../constant/apiUrl";
import { showSuccessToast } from "../../utils/Toast/toast";
import { useSelector } from "react-redux";

const ActionModal = ({
  title,
  isOpen,
  onClose,
  data,
  actionType,
  refreshData,
  setArchivesLoaded,
}) => {
  const { flagUser } = useSelector((store) => store?.user);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const getActionConfig = () => {
    switch (actionType) {
      case "republish":
        return {
          api: `${BASE_URL}/curator/archived/republish-content`,
          payload: {
            contentGuid: data?.contentGuid,
            republishedReason: reason,
            uploadedBy: `${flagUser?.firstName} ${flagUser?.lastName}`,
            uploadedDate: date,
          },
          successMsg: "Content republished successfully!",
          primaryLabel: "Republish",
          primaryIcon: "published_with_changes",
          reasonLabel: "Reason to Republish",
          showDate: true,
          showWarning: false,
          warningMsg: "",
          mandatory: true,
          maxReasonLength: 250,
        };

      case "archive":
        return {
          api: `${BASE_URL}/curator/archive-content`,
          payload: {
            contentGuid: data?.contentGuid,
            rejectedExplanation: reason,
            uploadedBy: `${flagUser?.firstName} ${flagUser?.lastName}`,
            uploadedDate: date,
          },
          successMsg: "Content archived successfully!",
          primaryLabel: "Archive",
          primaryIcon: "archive",
          reasonLabel: "Reason to Archive",
          showDate: true,
          showWarning: false,
          warningMsg: "",
          mandatory: true,
          maxReasonLength: 250,
        };

      case "delete":
        return {
          api: `${BASE_URL}/curator/delete-content`,
          payload: {
            contentGuid: data?.contentGuid,
            deleteReason: reason,
            contentId: data?.contentId,
          },
          successMsg: "Content deleted successfully!",
          primaryLabel: "Delete",
          primaryIcon: "delete",
          reasonLabel: "Reason to Delete",
          showDate: true,
          showWarning: true,
          warningMsg: "Please be aware that this action cannot be undone",
          mandatory: true,
          maxReasonLength: 250,
        };

      default:
        return {};
    }
  };

  const handleSubmit = async () => {
    const config = getActionConfig();
    if (!config?.api) return;

    if (config.mandatory) {
      if (!reason?.trim()) {
        setError(true);
        return;
      }
    }
    setError(false);
    setLoading(true);
    await postAPI(config?.api, config?.payload)
      .then(() => {
        showSuccessToast(config?.successMsg);
        setArchivesLoaded?.(false);
        refreshData?.();
        onClose();
      })
      .catch((err) => {
        console.error("Error:", err);
      })
      .finally(() => setLoading(false));
  };

  const config = getActionConfig();

  return (
    <>
      {loading && <Loading />}
      <Modal
        onCloseModal={onClose}
        showModal={isOpen}
        showAuxiliaryButton={false}
        closeOnOutsideClick={false}
        showTertiaryButton={false}
        showPrimaryButton={true}
        showSecondaryButton={true}
        hideCloseButton={false}
        showLink={false}
        title={title}
        type="S"
        primaryButtonProps={{
          text: (
            <>
              <Icon
                alt={config?.primaryLabel}
                className="$color-icon-default"
                icon={config?.primaryIcon}
                size="medium"
                style={{ color: "#fff", marginRight: "5px" }}
              />
              {config?.primaryLabel}
            </>
          ),
          variant: "primary",
          onClick: () => {
            void handleSubmit();
          },
        }}
        secondaryButtonProps={{
          text: "Cancel",
          variant: "secondary",
          onClick: onClose,
        }}
      >
        <Box sx={{ marginTop: "2.5rem" }}>
          {config?.showWarning && (
            <Typography variant="body2">{config?.warningMsg}</Typography>
          )}
        </Box>
        <Box sx={{ marginTop: "1.5rem" }}>
          <Typography variant="body2">Name</Typography>
          <TextField
            fullWidth
            size="small"
            value={data?.name || ""}
            disabled
            sx={{ mb: 2 }}
          />

          {config?.showDate && (
            <>
              <Typography variant="body2">Date</Typography>
              <TextField
                type="date"
                fullWidth
                size="small"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                sx={{ mb: 2 }}
                disabled
                // InputProps={{
                //   startAdornment: date && (
                //     <InputAdornment position="start">
                //       <IconButton onClick={() => setDate("")} size="small">
                //         <CloseIcon fontSize="small" />
                //       </IconButton>
                //     </InputAdornment>
                //   )
                // }}
              />
            </>
          )}

          <Typography variant="body2">{config?.reasonLabel}</Typography>
          <TextField
            multiline
            minRows={3}
            fullWidth
            maxLength={config?.maxReasonLength}
            size="small"
            value={reason}
            inputProps={{ maxLength: config?.maxReasonLength }}
            onChange={(e) => {
              if (e.target.value != "") {
                setError(false);
              } else {
                setError(true);
              }
              setReason(e.target.value);
            }}
            placeholder={`Enter ${config?.reasonLabel.toLowerCase()}`}
            error={error}
          />
        </Box>
      </Modal>
    </>
  );
};

export default ActionModal;
